import React from "react"

import FieldTags from "../../tags"

const debug = false
// const debug = "FieldTags_EditableValueHovered"

type Props = {
    field           : FieldTags
    model           : any

    onValueChange   : {(newValue: any): void}
}

export default function FieldTags_EditableValueHovered(props:Props) {
    const field = props.field as any as FieldTags
    const value = field.getViewValue(props.model)

    const onDeleteOption = (option:Option) => {
        const field     = props.field as any as FieldTags
        const newValue  = field.removeValue(props.model, option.value)
        props.onValueChange(newValue)
    }

    if (_.isEmpty(value)) {
        return <div className="ui5-color-no-accent">{props.field.placeholder}</div>
    }

    const valueOptions   = field._getOptions(value)

    return (
        <div className="multiselect-container">
            {_.map(valueOptions, option =>
                <field.components.Pill key          = {option.value}
                                       className    = "m-r-10"
                                       style        = {{maxWidth: field.pillMaxWidth}}
                                       option       = {option}
                                       onDelete     = {onDeleteOption}/>
            )}
        </div>
    )
}

